// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__rMYlB","search":"styles_search__9wKzt","option":"styles_option__8i_4p","trigger":"styles_trigger__bKBOh"};